import {
  Edit,
  SimpleForm,
  TextInput,
  PasswordInput,
  ReferenceArrayInput,
  SelectArrayInput,
  BooleanInput
} from "react-admin";
import {
  hasValue
} from "../../utils/schemas";
import * as Yup from "yup";
import { Grid } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import EditTitle from "../../ui/edit-title";
import CustomSaveToolbar from "../../ui/custom-save-toolbar";

const Schema = Yup.object(
{
  name: hasValue()
});

const AdminEdit = () =>
{
  return (
    <Edit
      title={<EditTitle subtitle="Editar Usuário Admin: " source="name" />}
      redirect="list"
      mutationMode="pessimistic">
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}
        toolbar={ <CustomSaveToolbar /> }>
        <Grid container columnSpacing={2} width="100%">
          <Grid size={{ xs: 1 }}>
            <TextInput source="id" label="Id" fullWidth disabled />
          </Grid>
          <Grid size={{ xs: 5 }}>
            <TextInput source="email" label="E-mail" type="email" fullWidth disabled />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <TextInput source="name" label="Nome" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <PasswordInput source="password" label="Senha" fullWidth />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <ReferenceArrayInput source="permissions_id" sort={{ field: "name", order: "ASC" }} reference="setup/permissions">
              <SelectArrayInput label="Permissão(ões)" optionText="name" optionValue="id" fullWidth />
            </ReferenceArrayInput>
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <BooleanInput source="active" label="Ativo" />
          </Grid>
          <Grid size={{ xs: 6 }} />
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export default AdminEdit;
